import { EditOfferProductAvailability } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";

function hasOnlyIneligibleBundles(
  productAvailability: EditOfferProductAvailability | undefined
): boolean {
  if (!productAvailability) {
    return false;
  }

  return (
    productAvailability.bundles.length === 0 &&
    productAvailability.ineligibleBundles.length > 0
  );
}

export { hasOnlyIneligibleBundles };
